<template>
  <v-row>
    <v-col cols="12">
      <v-card tile flat color="transparent">
        <v-card-title class="px-0 pt-0">
          <v-row align="center">
            <v-col>
              <div class="headline">Customers</div>
            </v-col>

            <v-col>
              <v-row>
                <v-spacer></v-spacer>
                <v-col>
                  <v-text-field
                    label="search"
                    outlined
                    filled
                    dense
                    hide-details="true"
                    v-model="search"
                    background-color="#fff"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto" v-if="$can('customers.create')">
                  <customer-create-modal
                    color="secondary"
                    depressed
                    height="40"
                  ></customer-create-modal>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-fade-transition mode="out-in">
            <v-row v-if="loading.customers" key="1">
              <v-col cols="4" v-for="index in 6" :key="index">
                <v-card outlined>
                  <v-skeleton-loader
                    type="table-heading, list-item-two-line"
                  ></v-skeleton-loader>
                </v-card>
              </v-col>
            </v-row>

            <v-fade-transition
              group
              tag="div"
              class="row"
              v-else-if="filteredCustomers.length"
              key="2"
              mode="in-out"
              leave-absolute
            >
              <v-col
                cols="4"
                v-for="customer in filteredCustomers"
                :key="customer.id"
              >
                <v-card
                  width="100%"
                  height="100%"
                  outlined
                  :to="{
                    name: 'customer',
                    params: { customer_id: customer.id }
                  }"
                >
                  <v-card-title>{{ customer.name }}</v-card-title>

                  <v-card-text>
                    <div class="body-1">Projects</div>
                    <div class="body-2">
                      {{ getProjectNames(customer.projects) }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-fade-transition>

            <v-row v-else key="3">
              <v-col cols="12">
                <v-card width="100%" outlined>
                  <v-card-text>
                    <div class="title">No customers found.</div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-fade-transition>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CustomerCreateModal from '@/components/customers/CustomerCreateModal'

export default {
  name: 'Customers',
  data: () => ({
    search: ''
  }),
  components: {
    CustomerCreateModal
  },
  computed: {
    ...mapGetters('customers', ['customers', 'loading']),
    filteredCustomers() {
      let regex = new RegExp(this.search, 'i')

      return this.customers.filter(({ name }) => name.match(regex)) || []
    }
  },
  methods: {
    ...mapActions('customers', ['fetchCustomers']),
    getProjectNames(projects) {
      let projectNames = projects.map(({ name }) => name)
      return projectNames.length ? projectNames.join(', ') : 'No projects.'
    }
  },
  created() {
    this.fetchCustomers()
  }
}
</script>
